// TODO: Update to Redux Toolkit
import { ThunkDispatch } from 'redux-thunk';
import { legacy_createStore as createStore, compose, applyMiddleware, Dispatch, Middleware, Action } from 'redux';
import { createMigrate, persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer, { RootState } from './rootReducer';
import { lastVersion, migrations } from './storeMigrations';
import {
  configureAuthenticationTokenPersistence,
  configureAuthenticationTokenStateReader,
} from 'infrastructure/security/authentication/tokenprovider/authenticationTokenRepository';

const middleware: Middleware =
  ({ dispatch, getState }: { dispatch: Dispatch; getState: () => unknown }) =>
  next =>
  action => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    return next(action);
  };

export type AppDispatch = ThunkDispatch<RootState, unknown, Action>;

const createExpireTransform = (
  expireMs = 30 * 24 * 60 * 60 * 1000, // 1 month
) =>
  createTransform(
    inboundState => ({
      data: inboundState,
      timestamp: Date.now(),
    }),
    (outboundState, key) => {
      if (!outboundState) return undefined;

      const { data, timestamp } = outboundState;
      const now = Date.now();

      if (now - timestamp > expireMs) {
        // eslint-disable-next-line no-console
        console.log(`[persist:${String(key)}] expired`);
        return undefined;
      }

      return data;
    },
    { whitelist: ['auth'] },
  );

const authExpireTransform = createExpireTransform();

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'auth',
    'authToken',
    'oneStopSettings',
    'journalEntriesSettings',
    'purchaseOrderSettings',
    'payrollReportsSettings',
    'employeeNames',
  ],
  transforms: [authExpireTransform],
  version: +lastVersion,
  migrate: createMigrate(migrations, { debug: false }),
};

// TODO: Update reduce types
const persistedReducer = persistReducer(persistConfig, rootReducer as any);

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(persistedReducer, undefined, composeEnhancers(applyMiddleware(middleware)));
const persistor = persistStore(store);

configureAuthenticationTokenPersistence({
  flush: () => persistor.flush(),
});

configureAuthenticationTokenStateReader(() => (store.getState() as any).authToken?.authenticationToken || null);

export { store, persistor };
